import { render } from "./Main.vue?vue&type=template&id=fa5f1cf2"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=fa5f1cf2&lang=css"
script.render = render

export default script